import { Skeleton } from '@ibsys/kit';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useEmployeesInfinite } from '@/entities/employee';
import { EmployeeForm } from './EmployeeForm';

type Props = {
  employeeId?: string;
};

export const EmployeeCard: FC<Props> = ({ employeeId }) => {
  const { t } = useTranslation('employees');
  const isCreateMode = employeeId === 'create';
  const numericId = isCreateMode ? undefined : employeeId ? Number(employeeId) : undefined;

  /* Ищем данные сотрудника в уже загруженном кэше списка */
  const { data, isLoading } = useEmployeesInfinite();

  const employee = useMemo(() => {
    if (!numericId || !data) return undefined;
    return data.pages.flatMap((p) => p.employees).find((e) => e.id === numericId);
  }, [numericId, data]);

  if (isLoading && numericId) {
    return <Skeleton className="h-full" />;
  }

  if (employee || isCreateMode) {
    return <EmployeeForm key={employee?.id ?? 'create'} initial={employee} />;
  }

  return <div className="flex items-center justify-center h-full text-muted-foreground">{t('selectEmployee')}</div>;
};
